class fontSizePX {
  constructor() {
    this.maxSize = 20
    this.startAtSize = 8
  }

  getFontSizes() {
    return [...Array(this.maxSize).keys()].map(
      i => ({value: i + this.startAtSize, label: `${i + this.startAtSize} px`})
    )
  }

  getFontSizePXValue(index) {
    const sizes = this.getFontSizes()
    const fontSize = sizes[index] ? sizes[index] : null
    return fontSize ? fontSize.value : null
  }
}

class textFormatter {
  constructor() {
    this.fontSizePX = new fontSizePX()
  }
}

export const fontSizesPX = () => new textFormatter().fontSizePX.getFontSizes()

export const fontSizePXValue = index => new textFormatter().fontSizePX.getFontSizePXValue(index)
